export const apiUrl = 'http://localhost:6543'
export const crawlerServiceUrl = 'http://localhost:5000'
